import { Controller } from '@hotwired/stimulus'
import { MAX_RESOLUTION_GROUP_NAME_LENGTH, MAX_RESOLUTION_NAME_LENGTH } from './constants'
import {
  PLEASE_ENTER_RESOLUTION_GROUP_NAME,
  PLEASE_ENTER_RESOLUTION_NAME,
  RESOLUTION_GROUP_NAME_ALREADY_EXISTS,
  RESOLUTION_GROUP_NAME_TOO_LONG,
  RESOLUTION_NAME_ALREADY_EXISTS,
  RESOLUTION_NAME_TOO_LONG,
  trans
} from '../../translator'

export default class extends Controller {
  static targets = ['modal', 'form', 'error', 'resolutionGroupsContainer', 'resolutionsContainer']

  connect () {
    $.fn.form.settings.rules.uniqueResolutionGroupName = (value) => {
      const normalised = value.trim().toLowerCase()
      return !Array.from(document.querySelectorAll('[data-controller="resolution-group"]'))
        .some(el => el.dataset.resolutionGroupNameValue.toLowerCase() === normalised)
    }

    $.fn.form.settings.rules.uniqueResolutionNameInGroup = (value, selfId) => {
      const normalised = value.trim().toLowerCase()
      if (!normalised) return true
      return !Array.from(this.resolutionsContainerTarget.querySelectorAll('input[type="text"]'))
        .some(input => input.id !== selfId && input.value.trim().toLowerCase() === normalised)
    }

    $(this.formTarget).form({
      fields: {
        resolution_group_name: {
          rules: [
            {
              type: 'empty',
              prompt: trans(PLEASE_ENTER_RESOLUTION_GROUP_NAME, {}, 'resolutions')
            },
            {
              type: `maxLength[${MAX_RESOLUTION_GROUP_NAME_LENGTH}]`,
              prompt: trans(RESOLUTION_GROUP_NAME_TOO_LONG, { '%parameter%': MAX_RESOLUTION_GROUP_NAME_LENGTH }, 'resolutions')
            },
            {
              type: 'uniqueResolutionGroupName',
              prompt: trans(RESOLUTION_GROUP_NAME_ALREADY_EXISTS, {}, 'resolutions')
            }
          ]
        }
      },
      inline: true,
      keyboardShortcuts: false
    })

    this.addResolutionValidationRule(0)
    this.addResolutionValidationRule(1)

    this.indexCounter = this.resolutionsContainerTarget.children.length
  }

  openModal (event) {
    event.preventDefault()
    this.hideError()
    this.resetForm()

    const modal = $(this.modalTarget)
    modal.modal('show')

    modal.one('shown.bs.modal', () => {
      const input = this.formTarget.querySelector('input')
      if (input) input.focus()
    })
  }

  resetForm () {
    $(this.formTarget).form('clear')
    while (this.resolutionsContainerTarget.children.length > 2) {
      this.resolutionsContainerTarget.removeChild(this.resolutionsContainerTarget.lastChild)
    }
  }

  addResolution () {
    const prototype = this.resolutionsContainerTarget.dataset.prototype
    const index = this.indexCounter++
    const newResolution = prototype.replace(/ptResolutionGroupResolution/g, index)

    this.resolutionsContainerTarget.insertAdjacentHTML('beforeend', newResolution)

    this.addResolutionValidationRule(index)
  }

  addResolutionValidationRule (index) {
    const newFieldName = `resolution_group_resolutions_${index}_name`
    const newFormRules = {
      [newFieldName]: {
        rules: [
          {
            type: 'empty',
            prompt: trans(PLEASE_ENTER_RESOLUTION_NAME, {}, 'resolutions')
          },
          {
            type: `maxLength[${MAX_RESOLUTION_NAME_LENGTH}]`,
            prompt: trans(RESOLUTION_NAME_TOO_LONG, { '%parameter%': MAX_RESOLUTION_NAME_LENGTH }, 'resolutions')
          },
          {
            type: `uniqueResolutionNameInGroup[${newFieldName}]`,
            prompt: trans(RESOLUTION_NAME_ALREADY_EXISTS, {}, 'resolutions')
          }

        ]
      }
    }

    const form = $(this.formTarget)
    const currentFormRules = form.form('setting', 'fields')
    form.form('destroy')
    form.form({
      fields: { ...currentFormRules, ...newFormRules },
      inline: true,
      keyboardShortcuts: false
    })
  }

  removeResolution (event) {
    const resolutionElement = event.currentTarget.closest('.resolution')
    const inputElement = resolutionElement.querySelector('input')
    if (inputElement && inputElement.id) {
      $(this.formTarget).form('remove field', inputElement.id)
    }

    resolutionElement.remove()
  }

  async submitForm (event) {
    event.preventDefault()
    this.hideError()

    if (!$(this.formTarget).form('is valid')) {
      $(this.formTarget).form('validate form')
      return
    }

    const submitButton = event.currentTarget
    submitButton.disabled = true
    submitButton.querySelector('i').classList.toggle('d-none')

    const name = this.formTarget.querySelector('#resolution_group_name').value
    const resolutions = Array.from(
      this.resolutionsContainerTarget.querySelectorAll('input[type="text"]')
    ).map(input => input.value)

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        body: JSON.stringify({ name, resolutions }),
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        $(this.modalTarget).modal('hide')

        const data = await response.json()
        this.resolutionGroupsContainerTarget.insertAdjacentHTML('beforeend', data.resolutionGroup)

        this.resetForm()
      } else {
        this.showError()
      }
    } catch (error) {
      this.showError()
    } finally {
      submitButton.disabled = false
      submitButton.querySelector('i').classList.toggle('d-none')
    }
  }

  showError () {
    this.errorTarget.classList.remove('d-none')
  }

  hideError () {
    this.errorTarget.classList.add('d-none')
  }
}
